<script context="module">
    import { client, clientForUser, gql } from "./GraphQL.svelte";
    import { register } from "./Auth.svelte";
    import { FIELDS_CONTENT_FRAGMENT } from "./Participaid.svelte";
    import Util from "./lib/util.js";

    function log(msg) {
        console.log(msg);
        return msg;
    }

    const logger = (res) => log(res);

    // TODO: replaced by model functions
    export function fullName(contributor) {
        return `${contributor.user.firstName} ${contributor.user.lastName}`
    }

    export function emptyValuation(contributor) {
        return {
            companySharePercentage: 0,
            contributorId: contributor.id,
            contributorName: fullName(contributor),
            numberOfStocks: 0,
            totalContributionWorth: 0
        };
    }

    export function color(contributor, colors) {
        return Util.guidToColor(contributor.id, colors);
    }

    // register for the first time to a project we have been invited to (or have created).
    // after this, the project shows up
    // but before entering the Contributor entity needs to still be made
    // by either the project owner or the user.
    //
    //# the project field was remobed by the Frans update on 17 Aug
    // project { id, fields { ${ FIELDS_CONTENT_FRAGMENT } } }
    const ADD_CONTRIBUTOR_MUTATION = gql`
        mutation($contributor: AddContributorInput!, $projectId: Guid!) {
            addContributor(contributor: $contributor, projectId: $projectId) {
                id,
                title,
                user { id, emailAddress }
            }
        }
    `;

    // TODO: make project resolvable from contributor
    const SET_CONTRIBUTOR_MUTATION = gql`
        mutation($contributor: UpdateContributorInput!, $projectId: Guid!) {
            updateContributor(contributor: $contributor, projectId: $projectId) {
                id,
                title,
                commissionPercentage,
                hourlySalary,
                marketAnnualSalary,
                user { id, emailAddress },

                #GraphQL.ExecutionError: Error trying to resolve project. ---> System.NotImplementedException: Cannot resolve Project for parent type Eyevestor.EValueAid.GraphQL.Models.GqlContributor
                #project { id }
            }
        }
    `;

    const REMOVE_CONTRIBUTOR_MUTATION = gql`
        mutation($id: Guid!, $projectId: Guid!) {
            deleteContributor(id: $id, projectId: $projectId) {
                id
            }
        }
    `;

    const ADD_PROJECT_USER_MUTATION = gql`
        mutation($user: InviteUserInput!, $projectId: Guid!) {
            inviteUser(user: $user, projectId: $projectId)
        }
    `;

    const ALL_PROJECT_CONTRIBUTORS = gql`
        query($projectId: String!) {
            contributors(projectId: $projectId) {
                commissionPercentage,
                currency,
                hourlySalary,
                id,
                marketAnnualSalary,
                startDate,
                title,
                user {
                    id, emailAddress
                }
            }
        }
    `;

    const RESEND_CONTRIBUTOR_INVITATION_QUERY = gql`
        query($projectId: Guid!, $contributorId: Guid!) {
            resendInvitation(projectId: $projectId, contributorId: $contributorId)
        }
    `;

    // invite a person to a project, using the complete lifecycle of...
    // registering a user through email...
    // invite a user to a project...
    // after which the user itself will have to fill their own contributor information
    export function invitePerson(projectId, email, firstName, lastName) {
        console.log(`[Contributor] Inviting person ${email} for #${projectId}`);

        let generatedPassword = "!" + Util.randomHash() + "0A";

        // register new user account
        return register({
            emailAddress: email,
            firstName: firstName || "",
            lastName: lastName || "",
            linkedInProfileName: "test", //dummy
            credentials: {
                username: email,
                password: generatedPassword
            }
        })
        // catch case where user for this email address already exists
        // TODO: crate api to get to know this
        .catch(err => {
            console.log(`error on user invitation (registration):`);
            console.log(err);
            debugger;
        })
        .then(res1 => {
            console.log(`[Contributor] Successfully registered User to invite`);
            //console.log(res1);

            // invite user account to project.
            // this creates an initial contributor entry with empty defaults.
            // the empty default should be set by the user themselves before trying
            // to generate a report, or all kinds of things will error out
            return inviteUser(projectId, {
                firstName,
                lastName,
                emailAddress: email
            })

            .then(res2 => {
                if (!res2)
                    throw `There was no result when trying ot invite ${email}!`;
                return all(projectId, true)
            })
            .then(logger)
            .then(contributorsRes => {
                console.log(`[Contributor] successfully invited User ${email} and invited to project #${projectId}`);
                console.log(contributorsRes);

                for (let contr of contributorsRes.data.contributors) {
                    if (contr.user.emailAddress == email) {
                        return {
                            emailAddress: email,
                            projectId,
                            generatedPassword,
                            contributor: contr,

                            //...res1.data.registerUser
                        };
                    }
                }
                throw "expected to find contributor for invited user!";
            })
        })
    }

    export function inviteUser(projectId, user) {
        return client.mutate({
            mutation: ADD_PROJECT_USER_MUTATION,
            variables: {
                projectId, user
            }
        })
        /*.then(res => {
            if (!res.data.inviteUser)
                throw `failed to invite user ${user.emailAddress} to project #${projectId}!`

        });*/
    }

    export function all(projectId, refresh) {
        return client.query({
            query: ALL_PROJECT_CONTRIBUTORS,
            // https://medium.com/@galen.corey/understanding-apollo-fetch-policies-705b5ad71980
            fetchPolicy: (refresh) ? "network-only" : "cache-first",
            variables: {
                projectId
            }
        });
    }

    export function resendInvitation(projectId, contributorId) {
        return client.mutate({
            mutation: RESEND_CONTRIBUTOR_INVITATION_QUERY,
            variables: {
                projectId, contributorId
            }
        });
    }

    export function addContributor(projectId, contributor, userToken) {
        let _client = (userToken) ? clientForUser(userToken) : client;
        return _client.mutate({
            mutation: ADD_CONTRIBUTOR_MUTATION,
            variables: {
                projectId, contributor
            }
        });
    }

    // dont waste too much round trips and just try to do it first
    export function addOrUpdateContributor(projectId, contributor, userToken) {
        return updateContributor(projectId, contributor, userToken)
            .catch(err => addContributor(projectId, contributor, userToken))
    }

    export function updateContributor(projectId, contributor, userToken) {
        let _client = (userToken) ? clientForUser(userToken) : client;
        return _client.mutate({
            mutation: SET_CONTRIBUTOR_MUTATION,
            variables: {
                projectId, contributor
            }
        });
    }

    export function removeContributor(projectId, contributorId) {
        return client.mutate({
            mutation: REMOVE_CONTRIBUTOR_MUTATION,
            variables: {
                projectId, id: contributorId
            }
        });
    }

</script>